import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSovereignPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-sovereign-philosophy" ref={ref} className={cn("bg-background relative overflow-hidden py-24 lg:py-32", "transition-opacity duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className="lg:col-span-5 flex flex-col gap-8 relative z-10">
            <div className="space-y-8">
              <h2 className="text-sm font-mono tracking-widest uppercase text-muted-foreground">
                Our Mission
              </h2>
              <h3 className="text-4xl md:text-5xl font-serif text-foreground leading-tight">
                The Sovereign Philosophy
              </h3>
              
              <div className="space-y-6 text-lg text-muted-foreground leading-relaxed font-sans">
                <p>Expat Legacy is an international advisory firm supporting globally mobile entrepreneurs in clarifying and organizing their international positioning.<div><br /></div><div>Through a strategic and pragmatic approach, we help clients align residency choices, business organization, and long-term life objectives into a coherent and sustainable direction.</div></p>
                
                <div className="text-foreground border-l-2 border-secondary pl-6 py-2 mt-8">
                  <p className="text-xl leading-relaxed">
                    Our mission is to build solid foundations for a chosen, sovereign, and internationally aligned life — structured for long-term clarity,{" "}
                    <span className="text-3xl font-medium text-secondary italic block mt-3 mb-1">
                      resilience
                    </span>{" "}
                    and{" "}
                    <span className="text-3xl font-medium text-secondary italic block mt-1">
                      freedom.
                    </span>
                  </p>
                </div>
              </div>
            </div>

            
          </div>

          {}
          <div className="relative h-full min-h-[500px] flex items-center justify-center !bg-[url(https://expat-legacy.com/wp-content/uploads/2026/02/abstract-gallery12.webp)] !rounded-lg lg:col-span-7 lg:min-h-[700px] lg:justify-end">
            {}
            <div className="absolute top-10 left-0 w-3/4 lg:w-2/3 z-0 opacity-60 translate-y-12 -translate-x-4 lg:-translate-x-12">
              
            </div>

            {}
            <div className="relative z-10 w-4/5 lg:w-3/5 shadow-2xl shadow-primary/5 translate-x-4 lg:translate-x-0 mt-12 lg:mt-0">
              
              
              {}
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}